(function () {

    const cartExpiration = window.cartExpiration;
    const expirationTimeKey = 'cartExpirationTime';

    function getExpirationTime() {
        const savedTime = localStorage.getItem(expirationTimeKey);
        return savedTime ? new Date(savedTime) : null;
    }

    function setExpirationTime() {
        const newExpirationTime = new Date(Date.now() + cartExpiration.expirationTime);
        localStorage.setItem(expirationTimeKey, newExpirationTime.toISOString());
        updateExpirationDisplay(newExpirationTime);

        startFrequentCheck();
    }

    function evictCart() {
        if (window.cartExpiration.expires == 'false') {
            updateExpirationDisplay(null);
            return;
        }
        localStorage.removeItem(expirationTimeKey);
        console.log('Cart has expired. Evicting cart...');
        fetch('/cart/clear.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
        })
            .then(response => response.json())
            .then(() => {
                localStorage.removeItem(expirationTimeKey);
                updateExpirationDisplay(null);
                location.reload();
            })
            .catch(error => console.error('Error evicting cart:', error));
    }

    function updateExpirationDisplay(expirationTime) {
        const timeElements = document.querySelectorAll('#ExpirationTime');
        timeElements.forEach(timeElement => {
            if (expirationTime) {
                timeElement.parentElement.classList.remove('hidden');
                const remainingTime = Math.max(0, expirationTime - new Date());
                const minutes = Math.floor(remainingTime / 60000);
                const seconds = Math.floor((remainingTime % 60000) / 1000);
                timeElement.textContent = `${minutes}:${seconds}`;
            } else {
                timeElement.parentElement.classList.add('hidden');
            }
        })
    }

    function startFrequentCheck() {
        if (this.intervalId) return;
        this.intervalId = setInterval(() => {
            const expirationTime = getExpirationTime();
            if (expirationTime && new Date() > expirationTime) {
                evictCart();
            } else {
                updateExpirationDisplay(expirationTime);
            }
        }, 900);
    }

    function subscribeToCartUpdates() {
        subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
            setExpirationTime();
        });
    }

    function initializeCartExpiration() {
        const expirationTime = getExpirationTime();

        if (expirationTime && new Date() > expirationTime) {
            evictCart();
        } else {
            setExpirationTime();
        }

        subscribeToCartUpdates();

    }

    document.addEventListener('DOMContentLoaded', initializeCartExpiration);
    subscribe(PUB_SUB_EVENTS.siteLoaded, initializeCartExpiration);
})();